module.exports = __webpack_public_path__ + "img/moon_half.0e07dd16.svg";